import { Component, ElementRef, Input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { MolstarPluginService } from 'src/app/molstar-plugin-service';
import { EntrySelectors } from 'src/app/state/entry.selectors';
import { UtilService } from 'src/app/util.service';
import { EntryData, Structure } from '../../structure-data.models';
import { PlatformService } from 'src/app/platform.service';
import { ConfigService } from 'src/app/config.service';
import { filter, tap } from 'rxjs';

@Component({
  selector: 'molstar-gallery',
  templateUrl: './molstar-gallery.component.html',
  styleUrl: './molstar-gallery.component.css',
  standalone: false
})
export class MolstarGalleryComponent {
 
  constructor(
    private store: Store,
    private utilService: UtilService,
    private el: ElementRef,
    private platform: PlatformService,
    private gaService: GoogleAnalyticsService,
    private configService: ConfigService,
    private molstarPluginService : MolstarPluginService,
  ) {}
  views = ['front', 'right', 'top'];
  currentIndex = 0;
  public structure: Structure;
  public pdbeMolstar: any;
  public originalCamera;
  public accession = toSignal(this.store.select(EntrySelectors.accession));
  public entryData = signal<EntryData>({} as EntryData);
  setView(index: number) {
    this.currentIndex = index;
    const direction = this.views[index];
    this.pdbeMolstar.visual.setViewDirection(direction, { durationMs: 500 })
  }

  next() {
    this.setView((this.currentIndex + 1) % this.views.length);
  }

  previous() {
    this.setView(
      (this.currentIndex - 1 + this.views.length) % this.views.length
    );
  }

  ngOnInit(): void {
    this.store
      .select(EntrySelectors.entryData)
      .pipe(
        filter(Boolean),
        tap((data) => {
          return this.entryData.set(data);
        })
      )
      .subscribe(() => {
        if (this.platform.isBrowserPlatform()) {
          this.initMolstar()
        }
      });
  }
  initMolstar(){
    this.structure = {
      model_url: this.entryData().bcifUrl,
      model_format: 'cif',
      binary: true,
    };
  
    setTimeout(() => {
      this.handleMolstar(this.structure);
    }, 100);
  }
  async handleMolstar(structure){
    const options = 
     {
      customData: {
        url: structure.model_url,
        format: structure.model_format,
        binary: structure.binary,
      },
      bgColor:  "white",
      alphafoldView: true,

      sequencePanel: false,
      hideCanvasControls: [ "expand",
      "controlToggle",
      "animation",
      "trajectory",
      "controlInfo",
      "selection"],
      hideControls: true,
      validationAnnotation: true,
      granularity: 'residue'
    }
    const ele = this.el.nativeElement.querySelector('#myViewer');

    if (ele) {
      await this.molstarPluginService.loadPlugin();
      const pluginInstance = this.molstarPluginService.createInstance();
      this.pdbeMolstar = pluginInstance;
      this.pdbeMolstar.render(ele, options);       
    }
  }
}
